import { render } from "./NeedsSection.vue?vue&type=template&id=2e0418ba"
import script from "./NeedsSection.vue?vue&type=script&lang=js"
export * from "./NeedsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__